/**
 * Core overlay IDs used across all brands
 */
export const OVERLAY_ID = {
    ACCOUNT_NAVIGATION: 'account-navigation',
    BASKET: 'basket',
    CATEGORY_FACET_GROUPS: 'category-facet-groups',
    CATEGORY_SORT_OPTIONS: 'category-sort-options',
    CHANGE_PASSWORD: 'change-password',
    ERROR_OVERLAY: 'error-overlay',
    NAVIGATION: 'navigation',
    NOTIFY_ME: 'notify-me',
    QUICKSHOP: 'quickshop',
    SEARCH: 'search',
    SEARCH_FACET_GROUPS: 'search-facet-groups',
    SEARCH_SORT_OPTIONS: 'search-sort-options',
    SHOP_THE_LOOK: 'shop-the-look',
    SITE_SELECTOR: 'site-selector',
    SIZEGUIDE: 'sizeguide',
    UNAUTHENTICATED: 'unauthenticated',
    WRONG_SITE_OVERLAY: 'wrong-site-overlay',
    ZOOM_GALLERY: 'zoom-gallery',
} as const;

/**
 * Dahlie specific overlay IDs
 */
export const DAHLIE_OVERLAY_ID = {
    NOT_WITHIN_TEAM_ORDERING_PERIOD: 'not-within-team-ordering-period',
    REMOVED_TEAM_PRODUCTS_FROM_BASKET: 'removed-team-products-from-basket',
    VALIDATE_TEAM_ACCOUNT: 'validate-team-account',
    VALIDATE_TEAM_ACCOUNT_SUCCESS: 'validate-team-account-success',
} as const;

/**
 * Sweet Protection specific overlay IDs
 */
export const SWEETPROTECTION_OVERLAY_ID = {
    COMPARE_LENSES: 'compare-lenses',
} as const;

export type OverlayId = (typeof OVERLAY_ID)[keyof typeof OVERLAY_ID];
export type DahlieOverlayId = (typeof DAHLIE_OVERLAY_ID)[keyof typeof DAHLIE_OVERLAY_ID];
export type SweetprotectionOverlayId = (typeof SWEETPROTECTION_OVERLAY_ID)[keyof typeof SWEETPROTECTION_OVERLAY_ID];
export type AnyOverlayId = OverlayId | DahlieOverlayId | SweetprotectionOverlayId;
